/* istanbul ignore file */
import { withAuthenticationRequired } from "react-oidc-context";
import { Route } from "react-router-dom";
import Loading from "./Loading";

const ProtectedRoute = ({ component, ...args }: any) => (
  <Route
    component={withAuthenticationRequired(component, {
      OnRedirecting: () => <Loading />,
    })}
    {...args}
  />
);

export default ProtectedRoute;